import fetchPricesEpic from './pricesEpic';
import setUserLocationEpic from './locationEpic';
import { authEventEpic, authIdentityEpic } from './authEpic';
import { checkoutEpic } from './checkoutEpic';
import { combineEpics } from 'redux-observable';
import {
  loadSpecFiltersEpic,
  reloadSpecFiltersOnPageNavigationEpic,
  updateSpecFilterSearchParamsEpic,
} from './specFiltersEpic';
import {
  jobsiteLocationPreferenceLoadEpic,
  jobsiteLocationPreferenceUpdateEpic,
} from './userPreferencesEpic';
import {
  isTaxExemptEpic,
  refreshCartItemsValidityEpic,
  resetCartPricesEpic,
  updateBackendCartEpic,
  updateQuoteEpic,
  updateRentalProtectionEpic,
  updateShiftEpic,
  validateAndUpdateDatesEpic,
  validateIsOrderPlacedForCurrentCart,
} from './cartEpic';
import {
  addJobsiteDetailsEpic,
  billingDetailsLoadEpic,
  companyDetailsLoadEpic,
  jobsiteDetailsLoadEpic,
  notificationDetailsLoadEpic,
  messageSettingsLoadEpic,
  personalDetailsLoadEpic,
  teamDetailsLoadEpic,
} from './profileEpic';
import { creditEpic } from './creditEpic';

const cartEpic = combineEpics(
  updateBackendCartEpic,
  updateQuoteEpic,
  updateShiftEpic,
  updateRentalProtectionEpic,
  validateIsOrderPlacedForCurrentCart,
  validateAndUpdateDatesEpic,
  refreshCartItemsValidityEpic,
  isTaxExemptEpic,
  resetCartPricesEpic
);
const pricesEpic = combineEpics(fetchPricesEpic);
const locationEpic = combineEpics(setUserLocationEpic);
const authEpic = combineEpics(authIdentityEpic, authEventEpic);
const profileEpic = combineEpics(
  personalDetailsLoadEpic,
  companyDetailsLoadEpic,
  billingDetailsLoadEpic,
  teamDetailsLoadEpic,
  jobsiteDetailsLoadEpic,
  addJobsiteDetailsEpic,
  notificationDetailsLoadEpic,
  messageSettingsLoadEpic,
);
const userPreferencesEpic = combineEpics(
  jobsiteLocationPreferenceLoadEpic,
  jobsiteLocationPreferenceUpdateEpic,
);

const checkoutCombinedEpic = combineEpics(checkoutEpic);
const specFiltersEpic = combineEpics(
  loadSpecFiltersEpic,
  updateSpecFilterSearchParamsEpic,
  reloadSpecFiltersOnPageNavigationEpic,
);

const rootEpic = combineEpics(
  locationEpic,
  creditEpic,
  cartEpic,
  pricesEpic,
  authEpic,
  profileEpic,
  userPreferencesEpic,
  checkoutCombinedEpic,
  specFiltersEpic,
);

export default rootEpic;
